import classNames from "classnames";
import React from "react";
import { LazyLoadImage } from "../../misc";

import "./HeroSection.scss";

export interface Props {
  images?: ILocationImage[];

  /**
   * Use `.wrap-children` to have the `.foreground` wrap below the image on mobile
   */
  className?: string;
  children?: React.ReactNode;
  heroImage?: ILocationImage | IContentImage;
}

/**
 * Displays a hero image with optional children
 *
 * On mobile, children can be made to wrap underneath the hero image with `.wrap-children`
 *
 * Styles overwritten/extended throughout the frontend codebase using `.hero-section`
 *
 * @status development
 */

export const HeroSection: React.FC<Props> = ({ children, className, heroImage, images }) => {
  const fallbackImage = images && images.length > 0 ? images[0] : "/images/missing-image.jpg";
  return (
    <div className={classNames("hero-section", className)}>
      <div className="background">
        <LazyLoadImage src={heroImage || fallbackImage} alt={heroImage?.meta || ""} />
      </div>
      {children &&
        <div className={classNames("foreground width-wrapper")}>
          {children}
        </div>
      }
    </div>
  );
};
